import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DepartureFromIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DepartureFromGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.875 22H6.20523C4.7402 22 3.54834 20.8081 3.54834 19.3431V18.5136C3.54834 18.2315 3.77664 18.0032 4.05878 18.0032C4.34092 18.0032 4.56922 18.2315 4.56922 18.5136V19.3431C4.56922 20.2454 5.30298 20.9791 6.20523 20.9791H18.875C19.7773 20.9791 20.511 20.2454 20.511 19.3431V6.46886C20.511 5.56662 19.7773 4.83286 18.875 4.83286H6.20523C5.30298 4.83286 4.56922 5.56662 4.56922 6.46886V11.0613C4.56922 11.3435 4.34092 11.5718 4.05878 11.5718C3.77664 11.5718 3.54834 11.3435 3.54834 11.0613V6.46886C3.54834 5.00384 4.7402 3.81198 6.20523 3.81198H18.875C20.3401 3.81198 21.5319 5.00384 21.5319 6.46886V19.3431C21.5319 20.8081 20.3401 22 18.875 22Z"
        fill="#696969"
      />
      <path
        d="M20.9721 9.71096H4.10813C3.82599 9.71096 3.59769 9.48266 3.59769 9.20052C3.59769 8.91838 3.82599 8.69008 4.10813 8.69008H20.9721C21.2543 8.69008 21.4826 8.91838 21.4826 9.20052C21.4826 9.48266 21.2543 9.71096 20.9721 9.71096Z"
        fill="#696969"
      />
      <path
        d="M8.41149 6.64432C8.12935 6.64432 7.90105 6.41602 7.90105 6.13388V2.51044C7.90105 2.2283 8.12935 2 8.41149 2C8.69363 2 8.92193 2.2283 8.92193 2.51044V6.13388C8.92193 6.41602 8.69363 6.64432 8.41149 6.64432Z"
        fill="#696969"
      />
      <path
        d="M16.6693 6.64432C16.3871 6.64432 16.1588 6.41602 16.1588 6.13388V2.51044C16.1588 2.2283 16.3871 2 16.6693 2C16.9514 2 17.1797 2.2283 17.1797 2.51044V6.13388C17.1797 6.41602 16.9514 6.64432 16.6693 6.64432Z"
        fill="#696969"
      />
      <path
        d="M9.93035 17.0431C9.79975 17.0431 9.66915 16.9932 9.56945 16.8935C9.37006 16.6941 9.37006 16.3711 9.56945 16.1717L11.4268 14.3144L9.56945 12.4571C9.37006 12.2577 9.37006 11.9347 9.56945 11.7353C9.76884 11.5359 10.0919 11.5359 10.2912 11.7353L12.5095 13.9535C12.7089 14.1529 12.7089 14.4759 12.5095 14.6753L10.2912 16.8935C10.1915 16.9932 10.0609 17.0431 9.93035 17.0431Z"
        fill="#696969"
      />
      <path
        d="M12.1486 14.8249H5.76107C5.47893 14.8249 5.25063 14.5966 5.25063 14.3144C5.25063 14.0323 5.47893 13.804 5.76107 13.804H12.1486C12.4307 13.804 12.659 14.0323 12.659 14.3144C12.659 14.5966 12.4307 14.8249 12.1486 14.8249Z"
        fill="#696969"
      />
    </svg>
  );
};

export default DepartureFromIcon;
